<template>
    <div class="section-box">
        <el-tabs v-model="form.status" type="card" class="customer-tabs-mg" @tab-click="handleSearch()">
            <el-tab-pane v-for="(item, index) in tabList" :label="item.value" :name="item.key + ''" :key="index+''">
            </el-tab-pane>
        </el-tabs>
        <div class="customer-list-service">
            <div class="next-button">
                <el-button size="small" type="primary" icon="el-icon-plus" plain @click="addoffer()">新增</el-button>
                <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="small" type="success" @click="handleReset">重置</el-button>
            </div>
        </div>
        <!-- eslint-disable  -->
        <el-table
                ref='table'
                :stripe="true"
                :data="tableData"
                style="width: 100%"
                height="670"
                border
                v-loading="listLoading"
                :key="toggleIndex"
        >
            <el-table-column label="服务编号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input type="number" size="mini" v-model="form.id" placeholder="请输入编号搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.id || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="服务名称">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.serviceName" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.serviceName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="所属一级产品">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.oneProductName" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.oneProductName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="所属二级产品">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.twoProductName" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.twoProductName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="所属三级产品">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.threeProductName" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.threeProductName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="服务类型">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.serviceStageName" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.serviceStageName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="类别">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select v-model="form.serviceType" placeholder="请选择" size="mini">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.serviceType==1">标准服务</span>
                        <span v-if="scope.row.serviceType==2">项目服务</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" fixed="right"  width="200">
                <template slot-scope="scope">
                    <el-button size="mini" @click="openDetail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="form.pageNum"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="form.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {getOfferList} from "@/service/dataFrame";
    import { getStorageUserRoleId,getActionData } from '@/utils/store'
    export default {
        name: "serviceLibrary",
        data(){
            return{
                options: [
                    {value: 0,label: '全部'},
                    {value: 1,label: '标准服务'},
                    {value: 2,label: '项目服务'}
                ],
                tableData:[],
                listLoading:false,
                form:{
                    id:'',
                    serviceName:'',//查询条件
                    productDomainName:'',//查询条件
                    oneProductName:'',//查询条件
                    twoProductName:'',//查询条件
                    threeProductName:'',//查询条件
                    serviceStageName:'',//查询条件
                    serviceType:0,
                    pageNum: 1,
                    pageSize: 10,
                    status: '1'
                },
                total: 0,
                searchData:{},
                toggleIndex:0,
                tabList:[
                    {key:'1',value:'有效服务'},
                    {key:'0',value:'无效服务'},
                ],
                oraginForm:{},
            }
        },
        activated(){
            this.handleSearch()
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
            this.handleSearch()
        },
        methods:{
            openDetail(data){
                this.$router.push({path:'/dataFrame/serviceDetails',query: {id: data.id}})
            },
            addoffer(){
                this.$router.push('/dataFrame/newServices')
            },
            handleSearch(){
                this.searchData = Object.assign({}, this.form)
                this.form.pageNum = 1;
                this.searchData.pageNum = 1;
                this.getServTypelist();
            },
            async getServTypelist(){
                this.listLoading = true;
                this.toggleIndex=this.form.status;
                let data = JSON.parse(JSON.stringify(this.searchData))
                !data.id && delete data.id
                !data.oneProductName && delete data.oneProductName
                !data.twoProductName  && delete data.twoProductName
                !data.threeProductName  && delete data.threeProductName
                !data.productDomainName && delete data.productDomainName
                !data.serviceName  && delete data.serviceName
                !data.serviceStageName  && delete data.serviceStageName
                !data.serviceType   && delete data.serviceType
                data.status=this.form.status==1?true:false
                let res = await getOfferList(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.datas || [];
                this.total = res.Data.total;
                this.$nextTick(() => {
                    this.$refs.table.bodyWrapper.scrollTop = 0
                    this.$refs.table.doLayout()
                })
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.pageNum = 1
                this.form.pageSize = val;
                this.searchData.pageNum = 1
                this.searchData.pageSize = val;
                this.getServTypelist();
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.pageNum = val;
                this.searchData.pageNum = val;
                this.getServTypelist();
            },
            // 重置
            handleReset() {
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
        }
    }
</script>

<style lang="scss">
    .customer-list-service {
        position: relative;

        .next-button {
            position: absolute;
            right: 0;
            top: -56px;
        }
    }
</style>
